import { whereOperators } from '@/lib/query-parameter/filter';
import { searchFieldOptionList, hubStatusOptionList, } from '@/constants/hubManagement';
import { addComma } from '@/utils/number';
const getters = {
    getterPageSize: ({ filterOption }) => Number(filterOption.pageSizeType),
    getterPageSizeType: ({ filterOption }) => filterOption.pageSizeType,
    getterHubStatusType: ({ filterOption }) => filterOption.hubStatusType,
    getterSearchValue: ({ filterOption }) => filterOption.searchWord.value,
    getterSearchField: ({ filterOption }) => filterOption.searchWord.field,
    getterHubList: ({ hubList }) => hubList ?? [],
    getterPaginationData: ({ paginationData }) => {
        const { pageNumber, pages, } = paginationData;
        return {
            pageNumber,
            pages,
        };
    },
    getterHubTotalLength: ({ paginationData }) => addComma(paginationData.total),
    getterSearchFieldTypeParam: ({ filterOption }) => {
        const [NAME, CEO_NAME, CEO_PHONE,] = searchFieldOptionList;
        const { value, field } = filterOption.searchWord;
        return {
            [NAME.value]: [
                {
                    condition: whereOperators.like,
                    field: NAME.field,
                    value,
                },
            ],
            [CEO_NAME.value]: [
                {
                    condition: whereOperators.like,
                    field: CEO_NAME.field,
                    value,
                },
            ],
            [CEO_PHONE.value]: [
                {
                    condition: whereOperators.like,
                    field: CEO_PHONE.field,
                    value,
                },
            ],
        }[field];
    },
    getterHubStatusTypeParam: ({ filterOption }) => {
        const [ALL, OK, LEAVE, STOP, REGISTER_REQUEST, DELETE,] = hubStatusOptionList;
        const { hubStatusType } = filterOption;
        return {
            [OK.value]: [
                {
                    condition: whereOperators.equals,
                    field: OK.field,
                    value: OK.value,
                },
            ],
            [LEAVE.value]: [
                {
                    condition: whereOperators.equals,
                    field: LEAVE.field,
                    value: LEAVE.value,
                },
            ],
            [STOP.value]: [
                {
                    condition: whereOperators.equals,
                    field: STOP.field,
                    value: STOP.value,
                },
            ],
            [REGISTER_REQUEST.value]: [
                {
                    condition: whereOperators.equals,
                    field: REGISTER_REQUEST.field,
                    value: REGISTER_REQUEST.value,
                },
            ],
            [ALL.value]: [
                {
                    condition: whereOperators.notEquals,
                    field: DELETE.field,
                    value: DELETE.value,
                },
            ],
        }[hubStatusType];
    },
};
export default getters;
